import { isApiMockingEnabled } from '@/utils/runtime-mode.utils'

export function registerApiMock(client, clientName) {
  if (!isApiMockingEnabled()) return

  client.interceptors.request.use(async config => {
    const { createMockAdapter } = await import('@/services/amio/runtime-mocks/amio-api.mock')
    const mockAdapterResponse = createMockAdapter(config, clientName)

    if (!mockAdapterResponse) return config

    config.adapter = () => Promise.resolve(mockAdapterResponse)
    return config
  }, error => Promise.reject(error))
}
